import React, { useState } from 'react';
import './RealtimeOversight.css';

function RealtimeOversight() {
  const [isVideoPlaying, setIsVideoPlaying] = useState(false);

  const handlePlayVideo = () => {
    setIsVideoPlaying(true);
  };

  return (
    <section className="RealtimeOversight pb-5 mt-5 pt-5 position-relative bg-dark">
      <div className="container">
        <h2 className="h1 pt-1 mb-4 text-light mt-5 text-center">Real-Time Oversight & Seamless Collaboration</h2>
        
        <div className="pb-5 pt-2 pt-sm-3 pt-lg-4 pt-xl-5">
        <div className="row g-4">
          
          {/* Left Column - Video */}
          <div className="col-12 col-lg-6">
            <div className="position-relative rounded-3" style={{ paddingBottom: '100%', height: 0 }}>
              {!isVideoPlaying ? (
                <div 
                  className="position-absolute top-0 start-0 w-100 h-100 rounded-3 shadow-lg cursor-pointer" 
                  onClick={handlePlayVideo}
                  style={{ 
                    cursor: 'pointer', 
                    overflow: 'hidden',
                    transition: 'transform 0.3s ease, box-shadow 0.3s ease'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'scale(1.02)';
                    e.currentTarget.style.boxShadow = '0 20px 40px rgba(0,0,0,0.3)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'scale(1)';
                    e.currentTarget.style.boxShadow = '';
                  }}
                >
                  <img 
                    src={`${process.env.PUBLIC_URL}/assets/home_page/v3/images/video-thumbnail.png`}
                    alt="Video Thumbnail"
                    className="w-100 h-100 rounded-3"
                    style={{ objectFit: 'cover' }}
                  />
                  <div 
                    className="position-absolute top-50 start-50 translate-middle play-button-hover"
                    style={{ 
                      zIndex: 10,
                      transition: 'transform 0.3s ease'
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = 'translate(-50%, -50%) scale(1.15)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = 'translate(-50%, -50%) scale(1)';
                    }}
                  >
                    <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="40" cy="40" r="40" fill="rgba(255, 255, 255, 0.9)" />
                      <path d="M32 24L56 40L32 56V24Z" fill="#6366F1" />
                    </svg>
                  </div>
                </div>
              ) : (
                <iframe
                  className="position-absolute top-0 start-0 w-100 h-100 rounded-3 shadow-lg"
                  src="https://www.youtube.com/embed/GReRpmRuSS4?autoplay=1"
                  title="Orbix Platform Demo"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                />
              )}
            </div>
          </div>

          {/* Right Column - Subtitle and Cards */}
          <div className="col-12 col-lg-6">
            {/* Subtitle */}
            <div className="mb-4">
              <p className="fs-lg text-light opacity-80 mb-0">This isn’t an archive pretending to be a workflow. Orbix is a fully integrated digital inspection platform that keeps your team connected and your projects moving.</p>
            </div>

            {/* Cards in 2x2 Grid */}
            <div className="row g-3">
              
              {/* Item 1 */}
              <div className="col-6">
                <div className="card card-v3 border-0 shadow h-100 text-start p-2 p-lg-3">
                  <div className="card-body card-body-v3 p-2">
                    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" className="mb-2">
                      <path d="M8 24L18 34L40 12" stroke="#02A783" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
                      <path d="M18 24L28 34L50 12" stroke="#02A783" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                    <p className="mb-0 mt-1 fs-sm  text-white">Approvals, rejections, and feedback happen in-platform</p>
                  </div>
                </div>
              </div>

              {/* Item 2 */}
              <div className="col-6">
                <div className="card card-v3 border-0 shadow h-100 text-start p-2 p-lg-3">
                  <div className="card-body card-body-v3 p-2">
                    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" className="mb-2">
                      <path d="M8 24L18 34L40 12" stroke="#02A783" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
                      <path d="M18 24L28 34L50 12" stroke="#02A783" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                    <p className="mb-0  mt-1 fs-sm  text-white">Data flows instantly from field to auditor</p>
                  </div>
                </div>
              </div>

              {/* Item 3 */}
              <div className="col-6">
                <div className="card card-v3 border-0 shadow h-100 text-start p-2 p-lg-3">
                  <div className="card-body card-body-v3 p-2">
                    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" className="mb-2">
                      <path d="M8 24L18 34L40 12" stroke="#02A783" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
                      <path d="M18 24L28 34L50 12" stroke="#02A783" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                    <p className="mb-0  mt-1 fs-sm text-white">No silos, no delays, no manual reconciliation</p>
                  </div>
                </div>
              </div>

              {/* Item 4 */}
              <div className="col-6">
                <div className="card card-v3 border-0 shadow h-100 text-start p-2 p-lg-3">
                  <div className="card-body card-body-v3 p-2">
                    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" className="mb-2">
                      <path d="M8 24L18 34L40 12" stroke="#02A783" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
                      <path d="M18 24L28 34L50 12" stroke="#02A783" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                    <p className="mb-0 mt-1  text-white fs-sm">Teams operate in sync across projects and locations</p>
                  </div>
                </div>
              </div>

            </div>
          </div>

        </div>
        </div>
      </div>
    </section>
  );
}

export default RealtimeOversight;

